import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 20v-11.5a4.5 4.5 0 1 0 -9 0v8.5","key":"svg-0"}],["path",{"d":"M11 14l-3 3l-3 -3","key":"svg-1"}]]

/**
 * IconUTurnLeft
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItdS10dXJuLWxlZnQiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE3IDIwdi0xMS41YTQuNSA0LjUgMCAxIDAgLTkgMHY4LjUiIC8+CiAgPHBhdGggZD0iTTExIDE0bC0zIDNsLTMgLTMiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/u-turn-left
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconUTurnLeft = createReactComponent('outline', 'u-turn-left', 'UTurnLeft', __iconNode);

export default IconUTurnLeft;